<!-- 延保条款 -->
<template>
  <div class="ml_term">
    <div class="ml_head">车辆评估报告保障服务</div>

    <div class="ml_title">1、关于车辆风险等级的说明</div>
    <div class="ml_content">
      <div>A：单次最高车损赔付比例＜5%</div>
      <div>B：5%≤单次最高车损赔付比例＜20%</div>
      <div>C：20%≤单次最高车损赔付比例＜45%</div>
      <div>D：45%≤单次最高车损赔付比例＜80%</div>
      <div>E：单次最高车损赔付比例≥80%</div>
      <p style="padding-top: 10px;">我们以单次最高车损赔付比例为基础对车辆进行评级，并在以上等级基础上，结合车辆历史车况、保险情况、交易情况等因素通过模型分析进行调整后最终确定车辆的风险等级。注：车辆风险等级达到“C\D\E”的车辆视为有重大事故。</p>
    </div>

    <div class="ml_title">2、车辆评估报告保障服务</div>
    <div class="ml_content">
      <p>博车平台为用户出具《车辆评估报告》，作为用户开展二手车交易或检测评估等事宜的参考，并与中国人保一同为报告中“车辆风险等级”判断结果的准确性、“重大事故、水淹、火烧”的风险排查情况进行保障。</p>
    </div>

    <div class="ml_title">3、保障服务有效期</div>
    <div class="ml_content">
      <p>报告出具之日起90天。</p>
    </div>

    <div class="ml_title">4、保障范围</div>
    <div class="ml_content">
      <p>在保障服务有效期内，该车辆发生首次交易后，用户因报告中“车辆风险等级”判断结果的准确性问题（即车辆风险等级达到“C\D\E”，本平台未判断出）、或“重大事故、水淹、火烧”的风险排查情况与事实不符而遭受了经济损失，可向本平台提供相应证明材料进行索赔。最高赔付10万元。</p>
      <p>用户需确保该车辆发生了真实有效的交易（所有权转移登记），具有真实合法的银行交易流水、车辆交易发票、交易合同。本平台核实后，确实属于评估结果不准确并可核实损失金额的，且用户将车辆交予本平台处置后，本平台按照赔偿标准赔偿用户的经济损失。</p>
      <p>
        <b>不予理赔的情况包括但不限于以下情况：</b>
      </p>
      <p>
        <b>1）车辆所有权变更登记时间超过评估保障服务有效期的；</b>
      </p>
      <p>
        <b>2）车辆不属于首次交易的；</b>
      </p>
      <p>
        <b>3）车辆交易未全部完成，如未支付完全部购车款或车辆权属未完成变更等；</b>
      </p>
      <p>
        <b>4）用户不配合本平台对车辆进行处置，或车辆因抵押、查封、扣押、事故、纠纷等不能进行权属变更的。</b>
      </p>
    </div>

    <div class="ml_title">5、赔偿标准</div>
    <div class="ml_content">
      <p>针对符合理赔规定的车辆，本平台的赔偿金额计算公式如下（赔偿金额限额为10万元）：</p>
      <p>赔偿金额 = 车辆交易价格 - 车辆折旧金额 - 最终处置价值 - 免赔金额。</p>
      <p>其中：</p>
      <p>
        车辆交易价格 = 用户提供被评估车辆的银行交易流水、车辆交易发票、交易合同可证明的交易价格；（车辆交易价格仅针对车辆本身交易金额，不包含以下费用：过户服务费、运输物流费、误工费、开票费、额外赔偿等其他费用。），其中银行交易流水、车辆交易发票、交易合同中金额不一致的，以金额最低的为准；
      </p>
      <p>车辆折旧金额 = 车辆交易价格 * 车辆使用月数 * 0.6%。（车辆使用月数按照本平台出具《车辆评估报告》之日起，至本平台首次收到用户索赔通知之日止计算；车辆使用不满一个月的部分，按照一个月计算）；</p>
      <p>最终处置价值 = 本平台协助用户进行车辆拍卖或以其他方式进行车辆处置后收回的价值。未经本平台书面同意，用户自行处置车辆的，本平台有权拒绝理赔。</p>
      <p>免赔金额 =（车辆交易价格 - 车辆折旧金额 - 最终处置价值） * 5%，不足3000元的按3000元计算。</p>
    </div>

    <div class="ml_title">6、理赔流程</div>
    <div class="ml_content">
      <div class="ml_content_item">
        <div class="ml_content_item_number">1）</div>
        <div class="ml_content_item_text">用户需在车辆首次交易完成后的30天内采用书面形式，通知本平台相关情况，并保留记录。</div>
      </div>
      <div class="ml_content_item">
        <div class="ml_content_item_number">2）</div>
        <div class="ml_content_item_text">本平台收到用户通知后，将书面回复用户，确认收到索赔信息。</div>
      </div>

      <div class="ml_content_item">
        <div class="ml_content_item_number">3）</div>
        <div class="ml_content_item_text">
          用户需在申请索赔后10个工作日内，收集相关证明材料以证明车辆在出具《车辆评估报告》前，车辆风险等级判断结果（即车辆风险等级达到“C\D\E”，本平台未判断出）或“重大事故、水淹、火烧”的风险排查情况与事实不符，并且用户因此遭受了损失，然后将相关材料以书面形式提交至本平台。证明材料包括但不限于：

          <div class="ml_content_item_content">
            <div class="ml_content_item_content_number">a）</div>
            <div class="ml_content_item_content_text">有资质的大型第三方车辆鉴定评估公司、公估公司或者资产评估公司出具的有效的车辆评估报告；</div>
          </div>

          <div class="ml_content_item_content">
            <div class="ml_content_item_content_number">b）</div>
            <div class="ml_content_item_content_text">正规维修商出具的盖章的车辆维修记录；</div>
          </div>
          <div class="ml_content_item_content">
            <div class="ml_content_item_content_number">c）</div>
            <div class="ml_content_item_content_text">正规保险公司的车险理赔记录；</div>
          </div>

          <div class="ml_content_item_content">
            <div class="ml_content_item_content_number">d）</div>
            <div class="ml_content_item_content_text">其他可以证明车辆在出具《车辆评估报告》前，车辆风险等级判断结果（即车辆风险等级达到“C\D\E”，本平台未判断出）或“重大事故、水淹、火烧”的风险排查情况与事实不符的材料；</div>
          </div>

          <div class="ml_content_item_content">
            <div class="ml_content_item_content_number">e）</div>
            <div class="ml_content_item_content_text">购车发票复印件、购车合同原件、银行交易流水。</div>
          </div>

        </div>
      </div>

      <div class="ml_content_item">
        <div class="ml_content_item_number">4）</div>
        <div class="ml_content_item_text">本平台收到证明材料进行审核后，会及时通知用户审核结果。审核材料不充分的，用户可在收到审核结果的5个工作日内继续补充理赔材料。5个工作日后，用户提供的材料无法充分证明原《车辆评估报告》中评估结果不准确的，本平台将拒绝本次理赔申请。</div>
      </div>

      <div class="ml_content_item">
        <div class="ml_content_item_number">5）</div>
        <div class="ml_content_item_text">
          经本平台核实，用户提供的材料可以充分证明原《车辆评估报告》中评估结果不准确的，本平台将接受本次索赔申请，并启动赔偿程序。用户需补充以下材料至本平台：
          <div class="ml_content_item_content">
            <div class="ml_content_item_content_number">a）</div>
            <div class="ml_content_item_content_text">车辆行驶本复印件；</div>
          </div>
          <div class="ml_content_item_content">
            <div class="ml_content_item_content_number">b）</div>
            <div class="ml_content_item_content_text">车辆登记证全本复印件；</div>
          </div>
          <div class="ml_content_item_content">
            <div class="ml_content_item_content_number">c）</div>
            <div class="ml_content_item_content_text">车主身份证信息；</div>
          </div>
          <div class="ml_content_item_content">
            <div class="ml_content_item_content_number">d）</div>
            <div class="ml_content_item_content_text">车主驾驶本信息。</div>
          </div>
        </div>
      </div>

      <div class="ml_content_item">
        <div class="ml_content_item_number">6）</div>
        <div class="ml_content_item_text">
          收到全部材料后，本平台将对车辆进行处置。
        </div>
      </div>

      <p>用户同意将该被评估车辆委托博车平台进行拍卖并办理相关手续。本平台将在车主配合、手续齐全的情况下，协助用户在45个工作日内完成车辆处置工作。用户需将最终处置完成的交易证明及时通过书面形式发送至本平台。本平台将在收到车辆处置完成信息后15个工作日内，按照前述赔偿标准，向用户进行赔偿。</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss">
.ml_term {
  padding: 0 15px 20px 15px;

  .ml_head {
    font-size: 22px;
    color: #332d29;
    text-align: center;
    font-weight: bold;
    padding: 20px 0;
  }

  .ml_title {
    font-size: 16px;
    color: #332d29;
    font-weight: bold;
    padding-bottom: 10px;
  }
  .ml_content {
    font-size: 14px;
    color: #332d29;
    line-height: 24px;
    margin-bottom: 10px;
    p {
      text-indent: 2em;
    }

    .ml_content_item {
      position: relative;
      padding-left: 20px;
      .ml_content_item_number {
        position: absolute;
        left: 20px;
        top: 0;
      }
      .ml_content_item_text {
        padding-left: 20px;
      }
    }

    .ml_content_item_content {
      position: relative;
      .ml_content_item_content_number {
        position: absolute;
        left: 0;
        top: 0;
      }
      .ml_content_item_content_text {
        padding-left: 20px;
      }
    }
  }
}
</style>